import Head from 'next/head';
import React from 'react';
import Authlayout from '../../components/widgets/auth-layout';
import SignUpWidget from '../../components/widgets/signup';

const SignUp = () => {
  return (
    <>
      <Head>
        <title>Signup</title>
        <meta
          name="description"
          content="A Simple Affiliate Cart System That Allows You: Take Affiliate Orders in Dollars & Major African Currencies By Simply Copying & Pasting a Single Line of Code on Your Website"
        />
        <link rel="icon" href="/favicon.png" />
      </Head>
      <Authlayout>
        <SignUpWidget />
      </Authlayout>
    </>
  );
};

export default SignUp;
